<template>
  <div class="container">
    <van-nav-bar title="设备激活" left-text="" left-arrow @click-left="onFinish" />
    <div class="main">
        <van-icon color="#67C23A" size="30" name="checked" />
          <span>设备激活成功！</span>
    </div>
   
    <div class="btnbox">
      <van-button type="info" size="large" @click="onFinish" 
        >完成</van-button
      >
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import { NavBar, Icon, Toast, Loading,  Field,  Button } from "vant";
export default {
  data() {
    return {     
      mainNo: "",
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Field.name]: Field,
 
  },
  methods: {
    onFinish() {
        this.$router.replace({ path: "home.html" });
    }, 
  },
  computed: {},
  created() {
    this.mainNo = this.$route.query.mainNo;  
  },
  mounted() {},
  destroyed() {},
};
</script>

<style lang="less" scoped>
body,
html {
  width: 100%;
  height: 100%;
  background: #fff;
}
.container {
  width: 100%;
  min-height: 100vh;
  letter-spacing: 0px;
  background: #fff;
}
.main{
  width: 100%;
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btnbox {
  margin-top: 20px;
  padding: 0 50px;
}
</style>
